import {
  Box,
  Link,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

const PrivacyPolicyContent = () => {
  return (
    <>
      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        1. Uvod
      </Typography>
      <Typography variant="body1" paragraph>
        Dobrodošli u aplikaciju Kantz, proizvod kompanije{" "}
        <strong>HOOLOOVOO DOO BEOGRAD (SAVSKI VENAC)</strong>, sa sedištem na
        adresi Ljutiće Bogdana 9, Beograd, matični broj: 20753013, PIB:
        107190299 („HOOLOOVOO“, „Mi“, „Naš“). Cenimo Vašu privatnost i posvećeni
        smo zaštiti Vaših podataka o ličnosti.
      </Typography>
      <Typography variant="body1" paragraph>
        U smislu primenjivih propisa Republike Srbije, ova Politika privatnosti
        predstavlja sveobuhvatno obaveštenje o obradi podataka o ličnosti u vezi
        sa Vašim korišćenjem naših alata za upravljanje radnim prostorima,
        uključujući bilo koji povezani softver, veb sajtove i usluge (zajedno
        označeni kao: „Usluge“). Naše Usluge uključuju Kantz aplikaciju
        („Aplikacija“), dostupnu putem našeg veb-sajta{" "}
        <Link
          href="https://otp.kantz.app"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          otp.kantz.app
        </Link>
        , koja je namenjena za rezervisanje radnih jedinica, odnosno mesta za
        rad koja uključuju radni sto i stolicu i prostorija za sastanke u
        deljenim kancelarijskim prostorima (Shared Office Space) ili u okviru
        kompanija koje raspolažu prostorom kapaciteta manjeg od ukupnog broja
        zaposlenih.
      </Typography>
      <Typography variant="body1" paragraph>
        Korisnici Kantz platforme su pravna lica koja koriste uslugu na osnovu
        licence, dok zaposleni kod tih pravnih lica ostvaruju pristup putem
        individualnih naloga i imaju mogućnost da bukiraju slobodno radno mesto
        u skladu sa raspoloživošću i unapred definisanim pravilima korišćenja.
      </Typography>
      <Typography variant="body1" paragraph>
        Molimo Vas da pažljivo pročitate ovu Politiku privatnosti kako biste
        razumeli koje podatke prikupljamo, na koji način ih obrađujemo, u koje
        svrhe i koja prava imate u vezi sa obradom Vaših podataka.
      </Typography>
      <Typography variant="body1" paragraph>
        Na ovu Politiku privatnosti i njene eventualne izmene i dopune
        primenjuju se propisi Republike Srbije, konkretno Zakon o zaštiti
        podataka o ličnosti (Službeni glasnik RS br. 87/2018) („ZZPL“) i prateći
        podzakonski propisi.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        2. Saglasnost sa politikama
      </Typography>
      <Typography variant="body1" paragraph>
        Vaše korišćenje naših Usluga uređeno je ovom Politikom privatnosti i
        našim{" "}
        <Link href="/terms-of-service" underline="hover">
          Uslovima korišćenja
        </Link>
        . Pristupanjem ili korišćenjem naših Usluga, potvrđujete da ste
        pročitali i razumeli Politiku privatnosti i Uslove korišćenja i
        obavezujete se da ih poštujete.
      </Typography>
      <Typography variant="body1" paragraph>
        Ukoliko niste saglasni sa bilo kojim pravilom naše Politike privatnosti
        ili Uslova korišćenja , molimo Vas da se uzdržite od korišćenja Usluga,
        odnosno da nam ne dostavljate Vaše podatke o ličnosti na bilo koji način
        (putem Aplikacije ili na drugi način).
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        3. Podaci o ličnosti koje prikupljamo
      </Typography>
      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        3.1 Podaci o ličnosti koje pružate
      </Typography>
      <List sx={{ listStyleType: "disc", pl: 4 }}>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Informacije o nalogu:</strong> Da biste koristili Kantz,
            možda će biti potrebno da kreirate nalog i unesete podatke kao što
            su ime, prezime, e-mail adresa i lozinka.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Poslovni profil:</strong> Možemo tražiti dodatne informacije
            kao što su vremenska zona, lokacija, naziv kompanije i kontakt
            podaci.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Komunikacije:</strong> Kada nam pišete putem podrške,
            učestvujete u anketama ili ostavljate komentare, čuvamo informacije
            o Vašem imenu, kontakt podatke, kao i podatke koje podelite
            konkretnom prilikom.
          </ListItemText>
        </ListItem>
      </List>

      <Typography variant="h6" component="h3" sx={{ mt: 2 }} gutterBottom>
        3.2 Podaci o ličnosti koje automatski prikupljamo
      </Typography>
      <List sx={{ listStyleType: "disc", pl: 4 }}>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Zapisnici i logovi:</strong> Podaci poput tipa pretraživača,
            IP adrese, jezičkih postavki i vremena pristupa.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Upotreba usluge:</strong> Pratimo kako koristite Aplikaciju,
            uključujući promene na Vašem nalogu.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Informacije o uređaju:</strong> Prikupljamo podatke o
            uređaju koji koristite (npr. operativni sistem, mreža, jedinstveni
            ID uređaja).
          </ListItemText>
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        4. Kolačići (Cookies) i tehnologije praćenja
      </Typography>
      <Typography variant="body1" paragraph>
        Koristimo kolačiće i slične tehnologije kako bismo poboljšali Vaše
        iskustvo korišćenja naših Usluga. Kolačići nam pomažu da zapamtimo Vaše
        postavke i omogućimo funkcije poput prijavljivanja. Koristimo analitičke
        i usluge praćenja kao što su Google Analytics, AppsFlyer, Moesif i
        HotJar da bismo razumeli kako koristite naše Usluge i poboljšali ih.
        Informacije koje na taj način prikupljamo u nekim slučajevima mogu biti
        podaci o ličnosti, ali i ne moraju biti.
      </Typography>
      <Typography variant="body1" paragraph>
        Kolačići su jednostavne tekstualne datoteke koje se čuvaju u
        veb-pregledaču korisnika, odnosno na njegovom uređaju. Zadatak kolačića
        je, pre svega, da omogući veb-sajtu da „prepozna“ korisnika kada mu ovaj
        naredni put pristupi. U toj situaciji, veb-sajt koristi podatke sačuvane
        u kolačiću i tako automatski dobija informaciju o prethodnoj aktivnosti
        korisnika na veb-sajtu. Kolačići ne mogu da pristupe Vašim podacima koje
        čuvate na uređajima, ali mogu da prikupljaju podatke o Vašim onlajn
        aktivnostima.
      </Typography>
      <Typography variant="body1" paragraph>
        Imate pravo da odlučite da li ćete prihvatiti kolačiće ili ne; međutim,
        odbijanje kolačića može uticati na funkcionalnost Usluga.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        5. Kako koristimo podatke o ličnosti i po kom osnovu
      </Typography>
      <Typography variant="body1" paragraph>
        Vaše podatke o ličnosti obrađujemo isključivo u meri u kojoj je to
        neophodno za jasno određene svrhe, i uvek na osnovu jednog od pravnih
        osnova predviđenih važećim propisima o zaštiti podataka o ličnosti.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Pružanje Usluga i korišćenje Aplikacije:</strong> Podatke koje
        nam sami pružate korišćenjem Usluga i kreiranjem naloga unutar
        Aplikacije, obrađujemo kako bismo Vam omogućili pristup Aplikaciji,
        kreiranje i administraciju korisničkih naloga, kao i rezervaciju radnih
        jedinica.
        <br />
        <em>
          Pravni osnov obrade je Vaš pristanak (član 12. stav 1. tačka 1. ZZPL)
          i izvršenje ugovora (član 12. stav 1. tačka 2. ZZPL).
        </em>
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Komunikacija sa korisnicima:</strong> Možemo koristiti Vaše
        kontakt podatke za potrebe pružanja korisničke podrške, slanja
        obaveštenja u vezi sa korišćenjem aplikacije (npr. bezbednosna
        upozorenja, izmene funkcionalnosti) i odgovaranja na Vaše upite.
        <br />
        <em>
          Pravni osnov obrade je naš legitimni interes da obezbedimo nesmetano
          funkcionisanje aplikacije (član 12. stav 1. tačka 6. ZZPL).
        </em>
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Analitika i unapređenje Aplikacije:</strong> Koristimo alate za
        analizu podataka poput HotJar, Google Analytics da bismo razumeli
        korisničke interakcije i poboljšali naše Usluge.
        <br />
        <em>
          Pravni osnov obrade je naš legitimni interes da unapređujemo
          aplikaciju i prilagodimo je potrebama korisnika (član 12. stav 1.
          tačka 6. ZZPL).
        </em>
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Zakonske obaveze:</strong> Podatke možemo obrađivati i otkrivati
        kada je to neophodno radi ispunjenja obaveza koje proizlaze iz zakona,
        kao što su obavezujući zahtevi državnih organa ili sudske odluke.
        <br />
        <em>
          Pravni osnov obrade je ispunjenje zakonskih obaveza (član 12. stav 1.
          tačka 3. ZZPL).
        </em>
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>Zaštita prava i bezbednosti:</strong> Vaše podatke možemo
        koristiti kako bismo zaštitili prava, imovinu i bezbednost HOOLOOVOO-a,
        naših korisnika ili javnosti, uključujući sprečavanje zloupotreba.
        <br />
        <em>
          Pravni osnov obrade je naš legitimni interes da obezbedimo zaštitu
          prava, imovinu i bezbednost HOOLOOVOO-a, naših korisnika ili javnosti
          (član 12. stav 1. tačka 6. ZZPL).
        </em>
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        6. Da li postoji obaveza davanja podataka?
      </Typography>
      <Typography variant="body1" paragraph>
        Dostavljanje podataka o ličnosti je dobrovoljno, ali u određenim
        slučajevima neophodno da biste mogli da koristite naše Usluge. Na
        primer, bez unosa osnovnih podataka za kreiranje naloga nećete moći da
        pristupite Aplikaciji ili rezervišete radnu jedinicu.
      </Typography>
      <Typography variant="body1" paragraph>
        Uvek zadržavate kontrolu nad time koje podatke delite sa nama i u kojoj
        meri, s tim što odbijanje davanja određenih podataka može ograničiti
        mogućnost korišćenja pojedinih funkcionalnosti Aplikacije.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        7. Primaoci podataka o ličnosti
      </Typography>
      <Typography variant="body1" paragraph>
        Vaše podatke obrađuje i koristi prevashodno HOOLOOVOO.
      </Typography>
      <Typography variant="body1" paragraph>
        U nekim slučajevima može biti potrebno da Vaše podatke učinimo dostupnim
        trećim stranama, odnosno primaocima. To mogu biti:
      </Typography>
      <List sx={{ listStyleType: "disc", pl: 4 }}>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pružaoci usluga:</strong> Delimo podatke sa partnerima kao
            što su AWS, Google, Microsoft i drugi koji nam pružaju usluge
            hostinga, komunikacije i analitike. Svi imaju sopstvene politike
            privatnosti i pozivamo Vas da se upoznate sa njihovom sadržinom.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pravni zahtevi:</strong> Možemo otkriti informacije
            nadležnim organima kada za to postoji zakonska obaveza.
          </ListItemText>
        </ListItem>
      </List>
      <Typography variant="body1" paragraph>
        Nastojaćemo da se sa Vašim podacima postupa na zakonit način i da treća
        lica, odnosno primaoci podataka, sa njima postupaju isključivo u skladu
        sa našim instrukcijama i ovim pravilima o zaštiti podataka o ličnosti,
        kao i da sami primenjuju odgovarajuće tehničke, organizacione i
        kadrovske mere u cilju zaštite podataka o ličnosti. Bez obzira na to
        kojim trećim stranama, odnosno primaocima su Vaši podaci učinjeni
        dostupnim, imate prava koja su Vam garantovana propisima Republike
        Srbije i koja su navedena u odeljku 9. ove Politike privatnosti.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        8. Koliko dugo čuvamo podatke?
      </Typography>
      <Typography variant="body1" paragraph>
        Vaše podatke o ličnosti čuvamo samo onoliko dugo koliko je neophodno za
        ostvarenje svrha za koje su prikupljeni, a nakon isteka tog perioda
        podatke ćemo bezbedno obrisati ili anonimizovati, osim ako njihovo duže
        čuvanje nije propisano zakonom ili je potrebno radi zaštite naših prava
        i interesa.
      </Typography>
      <Typography variant="body1" paragraph>
        U skladu sa navedenim:
      </Typography>
      <List sx={{ listStyleType: "disc", pl: 4 }}>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Podaci o nalogu</strong> (ime, prezime, e-mail adresa,
            lozinka) čuvaju se za vreme trajanja korisničkog naloga i brišu se
            nakon njegovog brisanja, osim ako je njihovo duže čuvanje neophodno
            radi ispunjenja zakonskih obaveza ili zaštite pravnih zahteva.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Podaci iz komunikacije</strong> (upiti, komentari, odgovori
            putem korisničke podrške, učešće u anketama) čuvaju se do 12 meseci
            od završetka poslednje komunikacije, osim ako je potrebno duže
            čuvanje radi rešavanja zahteva, sporova ili pravnih obaveza.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Zapisnici i logovi</strong> (npr. IP adresa, tip pregledača,
            jezičke postavke, vreme pristupa) čuvaju se do 12 meseci, nakon čega
            se automatski brišu ili anonimizuju.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Podaci o korišćenju aplikacije</strong> (promene na nalogu,
            aktivnosti korisnika) čuvaju se dok je nalog aktivan, odnosno dok je
            to neophodno radi pružanja i unapređenja funkcionalnosti aplikacije.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Podaci o uređaju</strong> (operativni sistem, mreža,
            jedinstveni ID uređaja) čuvaju se do 12 meseci od dana prikupljanja,
            osim ako su potrebni duže za dijagnostiku i bezbednosne svrhe.
          </ListItemText>
        </ListItem>
      </List>
      <Typography variant="body1" paragraph>
        Vaši podaci mogu biti čuvani i duže ukoliko je to neophodno radi
        ispunjenja zakonskih obaveza, vođenja postupaka pred nadležnim organima
        ili zaštite naših prava i interesa.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        9. Vaša prava u vezi sa obradom podataka
      </Typography>
      <Typography variant="body1" paragraph>
        Važno nam je da znate da imate određena prava u vezi sa obradom podataka
        o ličnosti koja su garantovana zakonom i koja se ostvaruju pod
        propisanim uslovima.
      </Typography>
      <List sx={{ pl: 2 }}>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pravo na pristup</strong> - imate pravo da zahtevate
            informaciju o tome da li obrađujemo Vaše podatke o ličnosti, kao i
            pristup tim podacima. Na Vaš zahtev dostavićemo Vam kopiju Vaših
            podataka koje obrađujemo.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pravo na ispravku i dopunu</strong> - imate pravo da se
            netačni podaci koji se odnose na Vas isprave bez nepotrebnog
            odlaganja, kao i da se nepotpuni podaci dopune, što uključuje i
            davanje dodatne izjave.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pravo na brisanje podataka</strong> - imate pravo da
            zahtevate brisanje Vaših podataka, a naročito: ako podaci više nisu
            neophodni za ostvarivanje svrhe; ako ste opozvali pristanak na
            osnovu kojeg se obrada vršila; ako ste podneli prigovor na obradu u
            skladu sa zakonom.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pravo na ograničenje obrade</strong> - imate pravo da se
            obrada Vaših podataka ograniči ako osporavate tačnost podataka; ako
            je obrada nezakonita a protivite se brisanju; ako nama podaci više
            nisu potrebni ali ste ih Vi zatražili radi pravnog zahteva; ako ste
            podneli prigovor na obradu.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pravo na prigovor</strong> - ako smatrate da je to opravdano
            u odnosu na posebnu situaciju u kojoj se nalazite, imate pravo da u
            svakom trenutku podnesete prigovor na obradu Vaših podataka o
            ličnosti koja se vrši na osnovu legitimnog interesa.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pravo na prenosivost podataka</strong> - imate pravo da
            podatke koje ste nam dostavili primite u strukturisanom, uobičajeno
            korišćenom i elektronski čitljivom obliku i pravo da ove podatke
            prenesete drugom rukovaocu.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pravo na opoziv pristanka</strong> - ako se obrada vrši na
            osnovu Vašeg pristanka, imate pravo na opoziv pristanka u bilo koje
            vreme, pri čemu opoziv ne utiče na dopuštenost obrade pre opoziva.
          </ListItemText>
        </ListItem>
        <ListItem sx={{ p: 0, pb: 1 }}>
          <ListItemText>
            <strong>Pravo na podnošenje pritužbe</strong> - imate pravo da
            podnesete pritužbu povodom obrade Vaših podataka o ličnosti
            nadležnom organu nadzora u Republici Srbiji. Kontakt podaci su u
            nastavku:
          </ListItemText>
        </ListItem>
      </List>

      <Box
        sx={{
          bgcolor: "grey.100",
          p: 2,
          borderLeft: "4px solid",
          borderColor: "primary.main",
          my: 2,
          borderRadius: 1,
        }}
      >
        <Typography variant="body1" fontWeight="bold">
          Poverenik za informacije od javnog značaja i zaštitu podataka o
          ličnosti
        </Typography>
        <Typography variant="body1">
          Adresa: Bulevar kralja Aleksandra 15, 11120 Beograd, Srbija
        </Typography>
        <Typography variant="body1">
          Mejl:{" "}
          <Link href="mailto:office@poverenik.rs">office@poverenik.rs</Link>
        </Typography>
        <Typography variant="body1">Telefon: +381 11 3408 900</Typography>
      </Box>

      <Typography variant="body1" paragraph>
        Ukoliko želite da se služite napred navedenim pravima, možete da nas
        kontaktirate na sledeći način:
      </Typography>
      <List sx={{ listStyleType: "disc", pl: 4 }}>
        <ListItem sx={{ display: "list-item", p: 0 }}>
          <ListItemText primary="pismom - na adresu: HOOLOOVOO DOO, Ljutice Bogdana 9, 11000 Beograd - Savski venac" />
        </ListItem>
        <ListItem sx={{ display: "list-item", p: 0 }}>
          <ListItemText
            primary={
              <span>
                elektronskom poštom - na mejl adresu:{" "}
                <Link href="mailto:support@kantz.app">support@kantz.app</Link>
              </span>
            }
          />
        </ListItem>
      </List>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        10. Sigurnost podataka
      </Typography>
      <Typography variant="body1" paragraph>
        Preduzimamo razumne mere kako bismo zaštitili Vaše informacije od
        neovlašćenog pristupa ili otkrivanja. Iako nijedna onlajn usluga nije
        potpuno sigurna, neprekidno pratimo naše Usluge radi ranjivosti i
        napada, pridržavajući se ISO 27001 standarda. Koristimo napredne
        enkripcijske standarde, uključujući TLS, kako bismo osigurali
        komunikacije. Pored toga, korisnici su odgovorni za zaštitu svojih
        akreditiva za nalog i osiguranje da njihov sadržaj bude u skladu s
        primenjivim zakonima i smernicama.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        11. Iznošenje podataka u inostranstvo
      </Typography>
      <Typography variant="body1" paragraph>
        Vaše podatke prevashodno koristimo na teritoriji Republike Srbije. Ipak,
        imajući u vidu da naše Usluge mogu biti dostupne globalno, može se
        javiti potreba da podaci budu dostupni i primaocima u inostranstvu.
      </Typography>
      <Typography variant="body1" paragraph>
        U vezi sa tim, prenos podataka može biti izvršen u države, delove
        teritorija ili sektore delatnosti, kao i međunarodne organizacije za
        koje je utvrđeno da obezbeđuju primereni nivo zaštite podataka o
        ličnosti, u skladu sa Listom država utvrđenom Odlukom Vlade Republike
        Srbije (Službeni glasnik RS br. 55/2019).
      </Typography>
      <Typography variant="body1" paragraph>
        Ukoliko se ukaže potreba da Vaše podatke učinimo dostupnim primaocima u
        državama za koje se ne smatra da obezbeđuju primereni nivo zaštite,
        obezbedićemo odgovarajući pravni osnov za takav prenos, što može
        uključivati zaključenje standardnih ugovornih klauzula usvojenih od
        strane nadležnog organa nadzora, kao i primenu drugih odgovarajućih mera
        zaštite. Time se obezbeđuje da svaki primalac bude obavezan da Vaše
        podatke štiti u skladu sa standardima propisanim zakonodavstvom
        Republike Srbije.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        12. Promene Politike privatnosti
      </Typography>
      <Typography variant="body1" paragraph>
        HOOLOOVOO može ažurirati ovu Politiku privatnosti s vremena na vreme.
        Pozivamo Vas da povremeno pregledate ovu politiku radi bilo kakvih
        promena. Ako budu izvršene značajne promene, obavestićemo Vas izmenom
        datuma datuma stupanja na snagu Politike, a u nekim slučajevima možemo
        pružiti dodatno obaveštenje (kao što je slanje obaveštenja putem
        e-pošte).
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        13. Kontakt
      </Typography>
      <Typography variant="body1" paragraph>
        Ako imate bilo kakva pitanja ili nedoumice u vezi sa ovom Politikom
        privatnosti ili obradom Vaših podataka o ličnosti, molimo Vas da nas
        kontaktirate na{" "}
        <Link href="mailto:support@kantz.app">support@kantz.app</Link>.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        14. Završne odredbe
      </Typography>
      <Typography variant="body1" paragraph>
        Radi izbegavanja sumnje, na sve što Politikom privatnosti nije izričito
        uređeno primenjivaće se propisi Republike Srbije, koje pravo će biti
        merodavno i u slučaju spora u vezi sa Politikom privatnosti, odnosno
        obradom podataka o ličnosti, a koji spor se ima rešavati pred stvarno
        nadležnim sudom u Beogradu, Republika Srbija.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4 }} gutterBottom>
        15. Datum stupanja na snagu
      </Typography>
      <Typography variant="body1" paragraph>
        Ova Politika privatnosti je na snazi od{" "}
        <strong>1. avgust 2025. godine.</strong>
      </Typography>
    </>
  );
};

export default PrivacyPolicyContent;
